import { useState } from "react"
import toast from "react-hot-toast"
import { Switch } from "~/ui/Switch"
import {
  PublishMediaKitDialog,
  PublishMediaKitVariant,
} from "./PublishMediaKitDialog"
import { usePublicMediaKitUpdate } from "./usePublicMediaKitUpdate"

// Saves as soon as it's flipped, separately from any surrounding form.
// Turning it on asks for confirmation first, because it makes the agency's
// roster and media kits public (ZAN-902).
export const PublicMediaKitSwitch = ({
  agencyId,
  variant,
  enabled,
  id,
  onChanged,
}: {
  agencyId: string
  variant: PublishMediaKitVariant
  enabled: boolean
  id?: string
  onChanged?: (enabled: boolean) => void
}) => {
  const { setPublished, loading } = usePublicMediaKitUpdate()
  const [confirmOpen, setConfirmOpen] = useState(false)

  return (
    <>
      <Switch
        id={id}
        aria-label="Public media kit"
        enabled={enabled}
        disabled={loading}
        setEnabled={(toggle) => {
          if (toggle) {
            setConfirmOpen(true)
          } else {
            void setPublished(agencyId, false).then((result) => {
              if (!result.ok) return
              toast.success("Media kit unpublished")
              onChanged?.(false)
            })
          }
        }}
      />
      <PublishMediaKitDialog
        agencyId={agencyId}
        variant={variant}
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        onPublished={() => onChanged?.(true)}
      />
    </>
  )
}
